module.exports["time"] = "_OpenHours__time";
module.exports["input"] = "_OpenHours__input";